<template>
  <div class="document-uploading full-size flex-vertical">
    <ModalWindow
      ref="deleteFileModalWindow"
      name="deleteFileModalWindow"
      header="Удаление элементов"
    >
      <div class="flex-vertical">
        <div class="delete-file-modal-window-text">
          Вы действительно хотите удалить это изображение?
        </div>
        <div class="delete-file-modal-window-buttons flex">
          <button
            @click="
              () => {
                deleteFile(selectedFileIndex);
                hideFileViewer();
              }
            "
          >
            Удалить
          </button>
          <button @click="hideDeleteFileModalWindow" class="gray-btn">
            Отменить
          </button>
        </div>
      </div>
    </ModalWindow>
    <div
      v-show="fileViewerIsShowed"
      class="document-file-viewer flex-vertical full-size"
    >
      <div class="document-file-viewer-header flex full-width">
        <div class="hide-file-viewer-button" @click="hideFileViewer">
          <img src="../../../public/icons/ArrowLeft.svg" />
        </div>
        <div
          class="delete-selected-file-button"
          @click="showDeleteFileModalWindow(selectedFileIndex)"
        >
          <img src="../../../public/icons/Trash.svg" />
        </div>
      </div>
      <div class="document-file-viewer-img flex-vertical full-size">
        <img :src="displayedFileSrc" class="file-preview full-size" />
      </div>
    </div>
    <div class="document-uploading-header font-bold-20px">
      {{ title }}
    </div>
    <input
      type="file"
      multiple
      ref="documentFiles"
      accept="image/*"
      id="documentFiles"
      class="document-files full-size"
      @change="saveUploadedFiles"
    />
    <div class="document-uploading-content flex-vertical full-height">
      <slot style="box-sizing: border-box;"></slot>
      <slot name="uploadingcomment" style="box-sizing: border-box;"></slot>
      <div class="document-uploading-files-preview full-size flex-vertical">
        <div v-for="(file, index) in files" 
             :key="index" 
             class="file-preview-container flex">
          <div @click="showDeleteFileModalWindow(index)"
               class="delete-file-button flex">
            X
          </div>
          <div @click="showFileViewer(index)"
               class="file-preview-name font-regular-16px vld-parent">
            <loading :active.sync="file.isLoading" :is-full-page="false" loader="dots"></loading>
            <span>{{ index + 1 }} - {{ file.name }}</span>
          </div>
        </div>
      </div>
      <div class="document-uploading-inputs flex full-size">
        <button v-if="files.length === 0" @click="openFileSelector">
          <span class="download-icon" />Загрузить документы
        </button>
        <template v-else>
          <button @click="openFileSelector">Загрузить</button>
          <button @click="selectNextStep">Далее</button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import UploadingFormMixin from "../mixins/UploadingFormMixin.js";
import ModalWindow from "../common/ModalWindow.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: "UploadingFormMobile",
  components: {
    ModalWindow,
    Loading
  },
  mixins: [UploadingFormMixin]
};
</script>

<style lang="scss" scoped>
@import "../../../src/styles/colors.scss";

.document-uploading {
  overflow: hidden;
  height: 100%;
}

.document-uploading-header {
  margin-bottom: 24px;
}

.document-uploading-content {
  overflow: hidden;
}

.document-uploading-inputs {
  align-items: flex-end;
  justify-content: space-evenly;
  flex-basis: 10%;
  // margin: 5px 0px;

  > button {
    min-width: 140px;
  }
}

.document-uploading-files-preview {
  overflow: auto;
}

.file-preview-container {
  margin: 6px 2px 6px;
  border-radius: 8px;
  background-color: $white-color;
  box-shadow: -1px 4px 3px rgba(0, 0, 0, 0.25), 1px 4px 3px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: background-color 0.5s ease;
  align-items: flex-start;
  box-sizing: border-box;
  height: auto;
  display: block;
}

.file-preview-container:hover {
  background-color: #e7e6e6;
}

.file-preview-name {
  user-select: none;
  word-break: break-all;
  flex-basis: 100%;
  margin: 5px;
  width: calc(100% - 34px);
  position: static;
}

.delete-file-button {
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  color: dimgray;
  font-family: IBMPlexSans-bold;
  cursor: pointer;
  transition: background-color 0.5s ease;
  float: right;
  margin-top: 6px;
  margin-bottom: -24px;
}

.delete-file-button:hover {
  color: $main-color;
}

.file-preview {
  padding: 5px;
  object-fit: contain;
}

.content-title {
  margin-bottom: 24px;
}

.document-files {
  display: none;
}

.delete-file-modal-window-text {
  margin-bottom: 84px;
}

.delete-file-modal-window-buttons {
  align-items: flex-start;

  button {
    margin-right: 8px;
  }
}

.document-file-viewer {
  position: fixed;
  top: 0px;
  left: 0px;
  display: flex;
  width: 100%;
  height: 100%;
  background-color: #000000;
  z-index: 1000;
}

.document-file-viewer-header {
  padding: 15px 15px 10px;
}

.document-file-viewer-img {
  justify-content: center;
  padding-bottom: 60px;
}

.hide-file-viewer-button {
  flex-basis: 100%;
}
</style>